<template>
  <div class="cbox">
    <div class="headbar flexBetween">
      <div class="flexStart" style="margin-top: 10px;">
        <el-breadcrumb separator="/">
          <el-breadcrumb-item :to="{ path: '/certfiles' }">根目录</el-breadcrumb-item>
          <el-breadcrumb-item v-for="(p,i) in pathList" :key="i">{{ p.filename }}</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="flexEnd">
<!--        <el-button v-if="$store.state.pmid > 1" size="small" type="primary" icon="el-icon-upload" @click="dialogVisible = true">文件上传</el-button>-->
        <el-button type="primary" icon="el-icon-download" size="small" plain @click="handleDownload">下载</el-button>
      </div>
    </div>
    <div class="bcontent">
      <div style="height:4px">
        <div id="processbox" style="height:4px;border-radius: 2px; background-color: green; width: 0px;"></div>
      </div>
      <el-alert v-if="$store.state.pmid > 1" type="error" :closable="false" title="提醒">
        <p>1.毕业生分类表必须上传</p>
        <p>2.毕业生就业统计表如果没有中职，只上传高职表格;如果有中高职需要上传:高职表、中职表和高中职总表。以上文件均为PDF格式。</p>
      </el-alert>
      <el-table stripe :data="DataList"
                style="width: 100%;margin-bottom: 20px; margin-top: 5px; color: #000;"
                border size="mini">
        <el-table-column prop="cover" label="类型" width="100">
          <template slot-scope="scope">
            <div style="text-align:center">

              <img v-if="scope.row.file_type=='file'" :src="'./img/icon/'+scope.row.exts+'.png?'"
                   class="typeicon"/>
              <img v-if="scope.row.file_type=='folder'" :src="'./img/icon/folder.png'" class="typeicon"/>
            </div>

          </template>
        </el-table-column>
        <el-table-column prop="filename" label="文件名称" min-width="120">
          <template slot-scope="scope">
            <div class="filenameitem flexBetween">
              <div @click.stop="viewInfo(scope.row)">
                <span>{{ scope.row.filename.lastIndexOf('.') > -1 ? scope.row.filename.substring(0,scope.row.filename.lastIndexOf('.')) : scope.row.filename }}</span>
                <span v-if="scope.row.file_type=='folder' && scope.row.nums < 2"
                      style="color:#f56c6c;">&nbsp;(未完成)</span>
                <span v-if="scope.row.file_type=='folder' && scope.row.nums >= 2"
                      style="color:#409eff;">&nbsp;(已完成)</span>
                <span v-if="scope.row.file_type=='file' && !scope.row.file_url"
                      style="color:#f56c6c;">&nbsp;(未完成)</span>
              </div>
              <div v-if="scope.row.file_url" class=" fileicon">
                <i class="el-icon-download" title="下载" @click.stop="openFile(scope.row)"></i>
                <i v-if="$store.state.pmid > 1" class="el-icon-delete" title="删除" @click.stop="remove(scope.row)" style="margin-left: 15px;"></i>
              </div>
              <div v-if="scope.row.file_type != 'folder' && !scope.row.file_url && $store.state.pmid > 1"
                   style="">
                <el-upload style="" action="" :http-request="uploadOss"
                           :on-progress="handleProcess"
                           :on-success="(e) => {uploadFile2(e,scope.row)}"
                           :show-file-list="false" accept=".pdf">
                  <el-button type="primary" size="small">点击上传</el-button>
                </el-upload>
              </div>
            </div>

          </template>
        </el-table-column>

        <el-table-column prop="id" label="上传日期" width="200">
          <template slot-scope="scope">
            {{ scope.row.file_url ? scope.row.created_at : '' }}

          </template>
        </el-table-column>

        <el-table-column prop="filename" label="文件大小" width="120">
          <template slot-scope="scope">
            {{ getSize(scope.row.file_size) }}

          </template>
        </el-table-column>
        <el-table-column prop="filename" label="上传用户" width="120">
          <template slot-scope="scope">
            <span
              style="vertical-align:middle;line-height: 32px; margin-left: 5px; color: #888;">{{ scope.row.username || scope.row.stu_name }}</span>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <el-dialog :visible.sync="dialogVisible" :close-on-click-modal="false" :modal-append-to-body="false"
               :destroy-on-close="true" @close="dialogVisible = false" width="600px" custom-class="cus_dialog">
      <div slot="title" class="flexBetween">
        <span style="color: #ffffff;">上传文件</span>
      </div>
      <div>
        <el-form :model="formData" ref="EditItem" label-width="120px">
          <el-form-item label="选择文件">
            <el-upload style="display: inline-block; margin-right: 20px" action="" :http-request="uploadOss"
                       :on-progress="handleProcess"
                       :on-success="uploadFiles"
                       :show-file-list="false">
              <el-button type="primary" size="small">点击上传</el-button>
            </el-upload>
            <ul v-if="formData.files && formData.files.length" class="el-upload-list el-upload-list--text" style="width: 320px;">
              <li class="el-upload-list__item is-success" v-for="(file,index) in formData.files" :key="index">
                <a class="el-upload-list__item-name"><i class="el-icon-document"></i>{{file.fileName}}</a>
                <label class="el-upload-list__item-status-label"><i class="el-icon-upload-success el-icon-circle-check"></i></label>
                <i class="el-icon-close" @click="handleRemoveFile(index)"></i></li></ul>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="saveForm">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  components:{},
  data() {
    return {
      dialogVisible: false,
      dialogVisible2: false,
      EditItem: {
        platform: "",
        qsx_pmid: "",
        sort: 0,
        modifyDateRange: []
      },
      tpmid:0,
      pid: 0,
      DataList: [],
      loginTimeRange:[],
      formData: {
        files: [],
      },
      pathList: [],
      currentRow: {},
    }
  },
  mounted() {
    if (this.$route.query.dir) {
      this.pid = this.$route.query.dir
    }
    this.getList();
  },
  watch: {
    $route: function (n, o) {
      let dir = n.query.dir
      if (dir) {
        this.getList()
      } else {
        this.pathList = []
        this.pid = 0
        this.getList()
      }
    }
  },
  methods: {
    getSize(size) {
      if (size) {
        if (size < 1024) {
          return size + "B"
        } else if (size >= 1024 && size < 1024 * 1024) {
          return parseInt(size / (1024) * 10) / 10 + "KB"
        } else if (size >= 1024 * 1024 && size < 1024 * 1024 * 1024) {
          return parseInt(size / (1024 * 1024) * 10) / 10 + "MB"
        } else if (size >= 1024 * 1024 * 1024 && size < 1024 * 1024 * 1024 * 1024) {
          return parseInt(size / (1024 * 1024 * 1024) * 10) / 10 + "GB"
        }
      } else {
        return "-"
      }
    },
    getList() {
      this.$http.post("/api/get_files_list", {
        pid: this.pid,
        type: 'jnjd',
      }).then(res => {
        this.DataList = res.data
        if (this.pid && !this.pathList.length) {
          this.pathList.push({filename: res.data[0].platform})
        }
      })
    },
    update(item) {
      item = Object.assign({}, item, {modifyDateRange: []})
      if (item.start_date) {
        item.modifyDateRange = [item.start_date,item.end_date]
      }
      this.EditItem = item;
      this.dialogVisible = true
    },
    uploadCover(e) {

      this.EditItem.image = e.src
    },
    add() {
      this.EditItem = {
        platform: "",
        qsx_pmid: "",
        sort: 0,
        modifyDateRange: [],
      }
      this.dialogVisible = true
    },
    remove(row) {
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http.post("/api/jymcfiles_delete", {
          id: row.id
        }).then(res => {
          this.$message({
            type: 'success',
            message: '删除成功'
          });
          this.getList();
        })

      }).catch(() => {

      });
    },
    saveForm() {
      let item = JSON.parse(JSON.stringify(this.formData));
      if (!item.files.length) {
        return this.$message.error('请上传文件')
      }
      let saveFile = idx => {
        if (idx < item.files.length) {
          let file = item.files[idx]
          let formData = {
            file_type: "file",
            exts: file.filetype,
            filename: file.fileName,
            file_size: file.size,
            file_url: file.src,
          }
          this.$http.post('/api/jymcfiles_edit', formData).then(res => {
            saveFile(idx + 1)
          });
        } else {
          this.dialogVisible = false
          this.$message({
            type: 'success',
            message: '保存成功'
          });
          this.getList()
        }
      }
      saveFile(0)
    },

    viewInfo(e) {
      if (e.file_type == "folder") {
        this.pid = e.id;
        this.pathList.push(e)
        window.location.href = "/#" + "/certfiles?dir=" + e.id
      } else {
        if (e.url) {
          this.openFile(e)
        }
      }
    },
    handleRemoveFile(idx) {
      this.formData.files.splice(idx, 1)
    },
    uploadFiles(e) {
      $("#processbox").hide()
      e.filetype = e.fileName.substr(e.fileName.lastIndexOf(".") + 1)
      e.is_share = 1
      this.formData.files.push(e)
    },
    handleProcess(e) {
      let p = e.loaded / e.total * 100
      $("#processbox").show().css("width", p + "%")
    },
    openFile(e) {
      if (e.file_url) {
        this.$http.get(e.file_url, {
          responseType: 'arraybuffer'
        }).then(r => {
          var blob = new Blob([r.data], { type: 'application/octet-stream;charset=UTF-8' })
          var downloadElement = document.createElement('a')
          var href = window.URL.createObjectURL(blob) // 创建下载的链接
          downloadElement.style.display = 'none'
          downloadElement.href = href
          downloadElement.download = decodeURIComponent(e.filename) // 下载后文件名
          document.body.appendChild(downloadElement)
          downloadElement.click() // 点击下载
          document.body.removeChild(downloadElement) // 下载完成移除元素
          window.URL.revokeObjectURL(href)
        })
      }
    },
    uploadFile2(e,row) {
      row.exts = e.fileName.substr(e.fileName.lastIndexOf(".") + 1)
      row.filename = row.filename.substring(0,row.filename.lastIndexOf('.')) + "." + row.exts;
      row.file_url = e.src
      row.file_size = e.size;
      this.$http.post('/api/jymcfiles_edit', row).then(res => {
        this.$message.success('上传成功')
        this.getList()
      });
    },
    handleDownload() {
      const loadInstance = this.$loading({
        lock: true,
        text: '下载中，请稍等...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      this.$http.post('/api/jymcfiles_download',{tpmid: this.pid,type:'jnjd'}).then(res => {
        loadInstance.close()
        window.open(res.data.url, '_blank')
      }).catch(() => {
        loadInstance.close();
      })
    },
  }
}
</script>

<style scoped>
.typeicon {
  width: 25px;
  height: 25px;
  border-radius: 4px;
  vertical-align: middle;
}
.filenameitem {
  position: relative;
}

.fileicon {
  position: absolute;
  right: 0;
  top: 0;
  z-index: 1;
  color: #409EFF;
  display: block;
}

.filenameitem:hover .fileicon {
  display: block;
}

.filenameitem:hover {
  color: #409EFF;
  cursor: pointer;
}

.nextpath {
  font-size: 14px;
  color: #409EFF;
  cursor: pointer;
}
</style>
